import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import i18n from '../../util/i18n'
import LanguageSelector from './LanguageSelector'
import { updateUserLanguage } from '../user/userSlice'
import isMobileView from '../../util/MobileView'
import {
  setSelectedLanguage, setAlertVisibleL, setAlertMessageL, resetLanguageForm
} from './LanguageSelectionSlice'

export const LanguageSelectionManager = ({ dispatch, userObj, t }) => {
  const navigate = useNavigate()

  const {
    selectedLanguage,
    alertVisible: setAlertVisible,
  } = useSelector((state) => state.languageForm)

  useEffect(() => {
    if (!selectedLanguage && userObj?.preferredLanguage) {
      dispatch(setSelectedLanguage(userObj.preferredLanguage))
    }
  }, [selectedLanguage])

  const handleLanguageChange = (event) => {
    dispatch(setSelectedLanguage(event.target.value))
  }

  const isMobile = isMobileView()
  const languageOptions = {
    'en-US': t('language-english'),
    'es-ES': t('language-spanish'),
    'it-IT': t('language-italian'),
    'ja-JP': t('language-japanese'),
    'ko-KR': t('language-korean'),
    'nl-NL': t('language-dutch'),
    'de-DE': t('language-german'),
    'pl-PL': t('language-polish'),
    'pt-PT': t('language-portuguese'),
    'fr-FR': t('language-french')
  }

  const handleLanguageSelectorError = (errorMessage) => {
    dispatch(setAlertMessageL(errorMessage))
    dispatch(setAlertVisibleL(true))
  }

  const handleSave = () => {
    const languageUpdatePayload = { preferredLanguage: selectedLanguage }

    dispatch(updateUserLanguage(languageUpdatePayload))
      .unwrap()
      .then(() => {
        i18n.changeLanguage(selectedLanguage)
        navigate('/account', { state: { editLanguageStatus: true } })
      })
      .catch(() => {
        handleLanguageSelectorError(t('error-saveFailed'))
      })
  }

  const languageSelectorComponent = (
    <LanguageSelector
      label={t('pref-lang-header')}
      value={selectedLanguage}
      onChange={handleLanguageChange}
      onSave={handleSave}
      onCancel={() => { dispatch(resetLanguageForm()) }}
      saveButtonText={t('button-save-changes')}
      cancelButtonText={t('button-cancel')}
      buttonStyles={{
        saveButton: 'cta-red-oval-edit-profile',
        cancelButton: 'cta-grey-oval'
      }}
      languageOptions={languageOptions}
      onError={handleLanguageSelectorError}
      isMobile={isMobile}
    />
  )

  return {
    languageSelectorComponent,
    setAlertVisible,
    languageOptions
  }
}
